import { IPopulationCsvRowError } from 'components/admin/shared/PopulationCsvUpload/types';
import { Form, SidePanel } from 'components/admin/ui';
import { Hr } from 'components/ui';
import pluralHelper from 'lib/helpers/pluralHelper';
import _ from 'lodash';
import css from './PopulationCsvErrorsSidePanel.module.scss';

interface IPopulationCsvErrorsSidePanelProps {
  isVisible: boolean;
  onClose: () => void;
  userCsvErrors: IPopulationCsvRowError[];
}

export const PopulationCsvErrorsSidePanel = ({
  userCsvErrors,
  isVisible,
  onClose,
}: IPopulationCsvErrorsSidePanelProps) => {
  const renderCsvErrorCount = () => {
    const errorCount = _.sumBy(userCsvErrors, (x) => _.size(x.errors));
    return `${errorCount} error${pluralHelper(errorCount)}`;
  };

  const renderCsvErrorItems = (errors: string[]) => {
    return (
      <ul>
        {_.map(errors, (error, index) => (
          <li key={index} className={css.error}>
            {error}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <SidePanel isVisible={isVisible} onClose={onClose}>
      <SidePanel.Header>
        <p className={css.title}>CSV Errors</p>
      </SidePanel.Header>
      <SidePanel.Body>
        <Form.Details className="mb-4">
          This CSV includes {renderCsvErrorCount()}. Please fix them and
          reupload the file.
        </Form.Details>

        <Hr />

        <div className={css.errorList}>
          {_.map(userCsvErrors, (x, i) => (
            <div className={css.errorItems} key={i}>
              <div className={css.email}>{x.email || 'Missing Email'}</div>
              <b>{renderCsvErrorItems(x.errors)}</b>
            </div>
          ))}
        </div>
      </SidePanel.Body>
    </SidePanel>
  );
};
